import { render, staticRenderFns } from "./CodingComponent.vue?vue&type=template&id=7f5c72cc&scoped=true&"
import script from "./CodingComponent.vue?vue&type=script&lang=js&"
export * from "./CodingComponent.vue?vue&type=script&lang=js&"
import style0 from "./CodingComponent.vue?vue&type=style&index=0&id=7f5c72cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c72cc",
  null
  
)

export default component.exports